const BetaBanner = () => {
  return (
    <div
      className="md:hidden fixed top-0 left-0 right-0 z-[60] bg-[hsl(275,100%,7%)] text-center py-1.5 px-6 text-[11px] leading-tight font-medium border-b border-brand-violet/20"
      role="status"
      aria-label="Desktop recommended notice"
      style={{ minHeight: '28px' }}
    >
      <span className="text-primary">
        Desktop Recommended — For full 50-mile radar precision and ad creative analysis, please view on a desktop.
      </span>
    </div>
  );
};

export default BetaBanner;
